<template>
  <div id="deviceMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>电脑信息</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:250px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机器类型::">
            <el-select v-model="pageSearch.deviceType"
                       clearable
                       placeholder="请选择机器类型">
              <el-option v-for="item in deviceType"
                         :key="item.value"
                         :label="item.label"
                         :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入机器ID/机器名称"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
              <!-- <i slot="prefix"
                 class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="changeType">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-row>
      <el-col :span="24"
              style="height: 10px"></el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  :row-class-name="tableRowClassName"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <!--<el-table-column prop="fSvrTime"-->
          <!--label="服务器时间"-->
          <!--width="170">-->
          <!--</el-table-column>-->
          <el-table-column prop="fCltTime"
                           label="客户端时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="fMacID"
                           align="right"
                           width="50"
                           label="ID">
          </el-table-column>
          <!-- <el-table-column prop="fCPUID"
                           label="CPU编号">
          </el-table-column>
          <el-table-column prop="fMacAddr"
                           label="Mac地址">
          </el-table-column> -->
          <el-table-column label="机器类型"
                           width="200">
            <template slot-scope="scope">
              {{scope.row.fMacType}}:{{scope.row.fMacName}}
            </template>
          </el-table-column>
          <!--<el-table-column prop="fMacType"-->
          <!--label="机器类型">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="fMacName"-->
          <!--label="机器名称">-->
          <!--</el-table-column>-->
          <el-table-column prop="fPriIP"
                           width="125"
                           label="IP">
          </el-table-column>
          <!-- <el-table-column prop="fCpuUsage"
                           align="right"
                           width="75"
                           label="CPU(%)">
          </el-table-column> -->
          <el-table-column prop="fMemUsage"
                           align="right"
                           width="110"
                           label="占用内存[KB]">
          </el-table-column>
          <el-table-column label="硬盘空间">
            <template slot-scope="scope">
              <el-tooltip placement="left">
                <div slot="content"
                     v-html="hddSizeStyle(scope.row.fHddSize)"></div>
                <span>{{scope.row.fHddSize}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="fProgName"
                           width="120"
                           label="程序名称">
          </el-table-column>
          <el-table-column prop="fProgVer"
                           align="right"
                           width="110"
                           label="程序版本">
          </el-table-column>
          <!-- <el-table-column prop="fMQTTStatus"
                           width="100"
                           label="MQTT状态">
          </el-table-column> -->
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="80">
            <template slot-scope="scope">
              <!-- <el-button size="mini"
                         type="danger"
                         @click="handleLog(scope.$index, scope.row)">日志</el-button> -->
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">参数</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogDevTitle"
               width="60%"
               top="7vh"
               :visible.sync="dialogFormVisible"
               v-dialogDrag>
      <el-row class="tip">
        <el-col :span="24"
                v-html="msg_tip">
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="deviceSetData"
                    v-loading="devSetLoading"
                    height="500"
                    border
                    stripe
                    style="width: 100%">
            <el-table-column prop="fCustNo"
                             label="客户编号"
                             width="80">
            </el-table-column>
            <el-table-column prop="fOpLastTime"
                             label="最后操作时间"
                             width="170">
            </el-table-column>
            <!-- <el-table-column prop="fCPUID"
                             label="CPU编号">
            </el-table-column>
            <el-table-column prop="fMacAddr"
                             label="Mac地址">
            </el-table-column> -->
            <el-table-column prop="fParmName"
                             label="参数名称">
            </el-table-column>
            <el-table-column prop="fParmVal"
                             label="参数值">
            </el-table-column>
            <!-- <el-table-column prop="fIsSyncData"
                             label="同步状态">
            </el-table-column> -->
          </el-table>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogDevLogTitle"
               top="7vh"
               width="65%"
               :visible.sync="dialogDevLogFormVisible"
               v-dialogDrag>
      <el-row class="tip">
        <el-col :span="24"
                v-html="msg_tip">
        </el-col>
      </el-row>
      <el-row class="log_search">
        <el-col :span="24">
          <el-select v-model="deviceLogParam.fIsExp"
                     placeholder="请选择日志类型"
                     clearable>
            <el-option v-for="item in logTypeArray"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input placeholder="请输入监控项目"
                    v-model="deviceLogParam.searchKeyWord"
                    class="search">
            <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
          </el-input>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="init_log">查询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="deviceLogData"
                    v-loading="devLogLoading"
                    :row-class-name="tableRowClassName"
                    height="500"
                    border
                    stripe
                    style="width: 100%">
            <!-- <el-table-column prop="fCustNo"
                             label="客户编号"
                             width="80">
            </el-table-column> -->
            <el-table-column prop="fSvrTime"
                             label="服务器时间"
                             width="170">
            </el-table-column>
            <el-table-column prop="fCltTime"
                             label="客户端时间"
                             width="170">
            </el-table-column>
            <!-- <el-table-column prop="fCPUID"
                               label="CPU编号">
              </el-table-column>
              <el-table-column prop="fMacAddr"
                               label="Mac地址">
              </el-table-column> -->
            <el-table-column prop="fUserNo"
                             width="100px"
                             label="用户编号">
            </el-table-column>
            <!-- <el-table-column prop="fPriIP"
                             label="IP">
            </el-table-column>
            <el-table-column prop="fSysName"
                             label="系统名称">
            </el-table-column> -->
            <el-table-column prop="fProcName"
                             label="进程名称">
            </el-table-column>
            <!-- <el-table-column prop="fKeyName"
                             label="关键字">
            </el-table-column> -->
            <el-table-column prop="fItemName"
                             label="监控项目">
            </el-table-column>
            <el-table-column prop="fItemMemo"
                             label="监控内容">
            </el-table-column>
            <el-table-column label="操作"
                             align="center"
                             fixed="right"
                             width="80">
              <template slot-scope="scope">
                <el-button size="mini"
                           type="success"
                           @click="handleLogInfo(scope.$index, scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogDevLogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle"
               width="50%"
               top="15vh"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form ref="form"
               :model="form"
               label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编号::">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作员编号::">
              <el-input v-model="form.fUserNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务器时间::">
              <el-input v-model="form.fSvrTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户端时间::">
              <el-input v-model="form.fCltTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="CPU编号::">
              <el-input v-model="form.fCPUID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mac地址::">
              <el-input v-model="form.fMacAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="IP::">
              <el-input v-model="form.fPriIP"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否异常::">
              <el-input v-model="form.fIsExpName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="系统名称::">
              <el-input v-model="form.fSysName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进程名称::">
              <el-input v-model="form.fProcName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关键字::">
              <el-input v-model="form.fKeyName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="监控项目::">
              <el-input v-model="form.fItemName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="监控内容::">
              <el-input v-model="form.fItemMemo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_export: false,
      dialogDevTitle: '',
      dialogDevLogTitle: '',
      dialogTitle: '',
      dialogVisible: false,
      form: {
        fCustNo: '',
        fBigRowID: '',
        fCustID: '',
        fSvrTime: '',
        fCltTime: '',
        fCPUID: '',
        fMacAddr: '',
        fUserID: '',
        fUserNo: '',
        fPriIP: '',
        fExpType: '',
        fSysName: '',
        fProcName: '',
        fKeyName: '',
        fItemName: '',
        fItemMemo: '',
        fIsExpName: ''
      },
      tableHeight: 0,
      dialogFormVisible: false,
      dialogDevLogFormVisible: false,
      deviceType: [{ label: '数据库服务器' }, { label: 'Web服务器' }, { label: '岗亭客户端' }, { label: '普通客户端' }, { label: '数据库岗亭合用机器' }],
      deviceLogParam: { fCustID: '', fCPUID: '', fMacAddr: '', searchKeyWord: '', fIsExp: '' },
      loading: false,
      devSetLoading: true,
      devLogLoading: true,
      pageData: [],
      msg_tip: '',
      logTypeArray: [
        {
          value: 1,
          label: '异常'
        },
        {
          value: 0,
          label: '正常'
        }
      ],
      cust_list: [],
      deviceSetData: [],
      deviceLogData: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        searchKeyWord: '',
        deviceType: '',
        fCustID: ''
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.init()
      }, 1000)
    },
    // 搜索词搜索
    wordSearch_log () {
      delay(() => {
        this.init_log()
      }, 1000)
    },
    init_log () {
      // this.deviceLogData = this.logData.filter(word => {
      //   if (this.log_type && this.deviceLogParam.searchKeyWord) {
      //     return word.fIsExp === this.log_type && (word.fSysName.indexOf(this.deviceLogParam.searchKeyWord) > -1 || word.fProcName.indexOf(this.deviceLogParam.searchKeyWord) > -1 || word.fKeyName.indexOf(this.deviceLogParam.searchKeyWord) > -1)
      //   } else if (this.log_type) {
      //     return word.fIsExp === this.log_type
      //   } else if (this.deviceLogParam.searchKeyWord) {
      //     return (word.fSysName.indexOf(this.deviceLogParam.searchKeyWord) > -1 || word.fProcName.indexOf(this.deviceLogParam.searchKeyWord) > -1 || word.fKeyName.indexOf(this.deviceLogParam.searchKeyWord) > -1)
      //   }
      //   return true
      // }
      // )
      this.devLogLoading = true
      device.custDevLogList(this.deviceLogParam).then(res => {
        this.devLogLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            // this.logData = data.Data || []
            this.deviceLogData = data.Data || []
          } else {
            this.$message.error('提示：加载客户设备日志信息失败')
          }
        }
      })
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      device.custDevPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载客户设备信息失败')
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsExp === '1') {
        return 'warning-row'
      }
      return ''
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.deviceSetData = []
      this.dialogFormVisible = true
      this.devSetLoading = true
      this.dialogDevTitle = '运行配置参数'
      if ((row.fCustName || '').length > 0) {
        this.dialogDevTitle = '【' + row.fCustName + '】运行配置参数'
      }
      this.msg_tip = '<span>机器ID：<span class="msg_value">' + row.fMacID + '</span></span> <span>机器类型：<span class="msg_value">' + row.fMacType + '</span></span><span>机器名称：<span class="msg_value">' + row.fMacName + '</span></span><span>IP：<span class="msg_value">' + row.fPriIP + '</span></span>'
      device.custDevSetList({ 'fCustNo': row.fCustNo, 'fCPUID': row.fCPUID, 'fMacAddr': row.fMacAddr }).then(res => {
        this.devSetLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.deviceSetData = data.Data || []
          } else {
            this.$message.error('提示：加载客户运行配置参数信息失败')
          }
        }
      })
    },
    loadCust () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // this.init()
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   // this.init()
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    handleLog (index, row) {
      this.deviceLogData = []
      this.dialogDevLogTitle = '设备日志'
      if ((row.fCustName || '').length > 0) {
        this.dialogDevLogTitle = '【' + row.fCustName + '】设备日志'
      }
      this.msg_tip = '<span>机器ID：<span class="msg_value">' + row.fMacID + '</span></span> <span>机器类型：<span class="msg_value">' + row.fMacType + '</span></span><span>机器名称：<span class="msg_value">' + row.fMacName + '</span></span><span>IP：<span class="msg_value">' + row.fPriIP + '</span></span>'
      this.deviceLogParam.fCustID = row.fCustID
      this.deviceLogParam.fCPUID = row.fCPUID
      this.deviceLogParam.fMacAddr = row.fMacAddr
      this.deviceLogParam.fIsExp = ''
      this.deviceLogParam.searchKeyWord = ''
      this.dialogDevLogFormVisible = true
      this.init_log()
    },
    changeType () {
      this.init()
    },
    handleLogInfo (index, row) {
      this.dialogTitle = '查看日志'
      this.dialogVisible = true
      device.custDevLogInfo(row.fBigRowID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.form = data.Data || {}
            this.form.fIsExpName = this.form.fIsExp === '1' ? '是' : '否'
            if ((this.form.fCustName || '').length > 0) {
              this.dialogTitle = '【' + this.form.fCustName + '】查看日志'
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    hddSizeStyle (size) {
      var html = ''
      if ((size || '').trim().length > 0) {
        var sizeArray = size.split(' ')
        sizeArray.forEach(e => {
          if ((e || '').length > 0) {
            html += e + '<br/>'
          }
        })
      }
      return html
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 70000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.loadCust()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#deviceMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#deviceMain .el-dialog__title {
  color: white;
}
#deviceMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#deviceMain .el-dialog__body {
  padding: 10px 10px 10px 10px;
}
#deviceMain .el-input.is-disabled .el-input__inner {
  color: #606266;
}
#deviceMain .warning-row {
  color: #f56c6c;
}
#deviceMain .tip span {
  padding-right: 10px;
  font-weight: bold;
  color: #ccc;
}
#deviceMain .tip span.msg_value {
  padding-right: 0px;
  color: darkseagreen;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/deviceMain.vue